import Vue from 'vue'
import VueApollo from 'vue-apollo'
import 'cross-fetch/polyfill'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import Cookie from 'universal-cookie'
import { InMemoryCache } from 'apollo-cache-inmemory'

Vue.use(VueApollo)

export default (ctx, inject) => {
  const providerOptions = { clients: {} }
  const { app, beforeNuxtRender, req } = ctx
  const AUTH_TOKEN_NAME = 'recess-apollo-production'
  const COOKIE_ATTRIBUTES = {"expires":7,"path":"\u002F","secure":false}
  const AUTH_TYPE = 'Bearer '
  const cookies = new Cookie(req && req.headers.cookie)
  const onCacheInitStore = { }

  // Config

      const defaultTokenName = ''  || AUTH_TOKEN_NAME

      function defaultGetAuth () {
        const token = cookies.get(defaultTokenName)
        return token && defaultClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let defaultClientConfig

        defaultClientConfig = require('~/apollo/client-configs/default')

        if ('default' in defaultClientConfig) {
          defaultClientConfig = defaultClientConfig.default
        }

        defaultClientConfig = defaultClientConfig(ctx)

      if (process.server) {
        onCacheInitStore['default'] = defaultClientConfig.onCacheInit
        defaultClientConfig.onCacheInit = null
      }

      const defaultValidateToken = () => true

      if (!defaultClientConfig.validateToken) {
        defaultClientConfig.validateToken = defaultValidateToken
      }

      const defaultCache = defaultClientConfig.cache
        ? defaultClientConfig.cache
        : new InMemoryCache(defaultClientConfig.inMemoryCacheOptions ? defaultClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        defaultCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.defaultClient : null)
      }

      if (!defaultClientConfig.getAuth) {
        defaultClientConfig.getAuth = defaultGetAuth
      }

      if (process.client && defaultClientConfig.browserHttpEndpoint) {
        defaultClientConfig.httpEndpoint = defaultClientConfig.browserHttpEndpoint
      }

      defaultClientConfig.ssr = !!process.server
      defaultClientConfig.cache = defaultCache
      defaultClientConfig.tokenName = defaultTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!defaultClientConfig.httpLinkOptions) {
          defaultClientConfig.httpLinkOptions = {}
        }
        if (!defaultClientConfig.httpLinkOptions.headers) {
          defaultClientConfig.httpLinkOptions.headers = {}
        }
        defaultClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let defaultApolloCreation = createApolloClient({
        ...defaultClientConfig
      })
      defaultApolloCreation.apolloClient.wsClient = defaultApolloCreation.wsClient

          providerOptions.defaultClient = defaultApolloCreation.apolloClient

      const storefrontTokenName = ''  || AUTH_TOKEN_NAME

      function storefrontGetAuth () {
        const token = cookies.get(storefrontTokenName)
        return token && storefrontClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let storefrontClientConfig

        storefrontClientConfig = require('~/apollo/client-configs/storefront')

        if ('default' in storefrontClientConfig) {
          storefrontClientConfig = storefrontClientConfig.default
        }

        storefrontClientConfig = storefrontClientConfig(ctx)

      if (process.server) {
        onCacheInitStore['storefront'] = storefrontClientConfig.onCacheInit
        storefrontClientConfig.onCacheInit = null
      }

      const storefrontValidateToken = () => true

      if (!storefrontClientConfig.validateToken) {
        storefrontClientConfig.validateToken = storefrontValidateToken
      }

      const storefrontCache = storefrontClientConfig.cache
        ? storefrontClientConfig.cache
        : new InMemoryCache(storefrontClientConfig.inMemoryCacheOptions ? storefrontClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        storefrontCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.storefront : null)
      }

      if (!storefrontClientConfig.getAuth) {
        storefrontClientConfig.getAuth = storefrontGetAuth
      }

      if (process.client && storefrontClientConfig.browserHttpEndpoint) {
        storefrontClientConfig.httpEndpoint = storefrontClientConfig.browserHttpEndpoint
      }

      storefrontClientConfig.ssr = !!process.server
      storefrontClientConfig.cache = storefrontCache
      storefrontClientConfig.tokenName = storefrontTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!storefrontClientConfig.httpLinkOptions) {
          storefrontClientConfig.httpLinkOptions = {}
        }
        if (!storefrontClientConfig.httpLinkOptions.headers) {
          storefrontClientConfig.httpLinkOptions.headers = {}
        }
        storefrontClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let storefrontApolloCreation = createApolloClient({
        ...storefrontClientConfig
      })
      storefrontApolloCreation.apolloClient.wsClient = storefrontApolloCreation.wsClient

          providerOptions.clients.storefront = storefrontApolloCreation.apolloClient

      const cartTokenName = ''  || AUTH_TOKEN_NAME

      function cartGetAuth () {
        const token = cookies.get(cartTokenName)
        return token && cartClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let cartClientConfig

        cartClientConfig = require('~/apollo/client-configs/storefront')

        if ('default' in cartClientConfig) {
          cartClientConfig = cartClientConfig.default
        }

        cartClientConfig = cartClientConfig(ctx)

      if (process.server) {
        onCacheInitStore['cart'] = cartClientConfig.onCacheInit
        cartClientConfig.onCacheInit = null
      }

      const cartValidateToken = () => true

      if (!cartClientConfig.validateToken) {
        cartClientConfig.validateToken = cartValidateToken
      }

      const cartCache = cartClientConfig.cache
        ? cartClientConfig.cache
        : new InMemoryCache(cartClientConfig.inMemoryCacheOptions ? cartClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        cartCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.cart : null)
      }

      if (!cartClientConfig.getAuth) {
        cartClientConfig.getAuth = cartGetAuth
      }

      if (process.client && cartClientConfig.browserHttpEndpoint) {
        cartClientConfig.httpEndpoint = cartClientConfig.browserHttpEndpoint
      }

      cartClientConfig.ssr = !!process.server
      cartClientConfig.cache = cartCache
      cartClientConfig.tokenName = cartTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!cartClientConfig.httpLinkOptions) {
          cartClientConfig.httpLinkOptions = {}
        }
        if (!cartClientConfig.httpLinkOptions.headers) {
          cartClientConfig.httpLinkOptions.headers = {}
        }
        cartClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let cartApolloCreation = createApolloClient({
        ...cartClientConfig
      })
      cartApolloCreation.apolloClient.wsClient = cartApolloCreation.wsClient

          providerOptions.clients.cart = cartApolloCreation.apolloClient

  const vueApolloOptions = Object.assign(providerOptions, {
      errorHandler (error) {
          console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
      }
  })

  const apolloProvider = new VueApollo(vueApolloOptions)
  // Allow access to the provider in the context
  app.apolloProvider = apolloProvider

  if (process.server) {
    const ApolloSSR = require('vue-apollo/ssr')
    beforeNuxtRender(({ nuxtState }) => {
      nuxtState.apollo = {}
      const states = ApolloSSR.getStates(apolloProvider)

      for (let clientName in states) {
        nuxtState.apollo[clientName] = Object.assign({}, states[clientName])
      }

      // Clear apollo client cache after each request
      // Issues: https://github.com/nuxt-community/apollo-module/issues/273
      //         https://github.com/nuxt-community/apollo-module/issues/251
      Object.keys(apolloProvider.clients).forEach(clientName => {
        const client = apolloProvider.clients[clientName]
        const onCacheInitKey = clientName === 'defaultClient' ? 'default' : clientName
        const onCacheInit = onCacheInitStore[onCacheInitKey]
        client.cache.reset()
        if (typeof onCacheInit === 'function') onCacheInit(client.cache)
      })
    })
  }

  inject('apolloHelpers', {
    onLogin: async (token, apolloClient = apolloProvider.defaultClient, cookieAttributes = COOKIE_ATTRIBUTES, skipResetStore = false) => {
      // Fallback for tokenExpires param
      if (typeof cookieAttributes === 'number') cookieAttributes = { expires: cookieAttributes }

      if (typeof cookieAttributes.expires === 'number') {
        cookieAttributes.expires = new Date(Date.now()+ 86400*1000*cookieAttributes.expires)
      }

      if (token) {
        cookies.set(AUTH_TOKEN_NAME, token, cookieAttributes)
      } else {
        cookies.remove(AUTH_TOKEN_NAME, cookieAttributes)
      }
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (setToken)', 'color: orange;', e.message)
        }
      }
    },
    onLogout: async (apolloClient = apolloProvider.defaultClient, skipResetStore = false) => {
      cookies.remove(AUTH_TOKEN_NAME, COOKIE_ATTRIBUTES)
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
        }
      }
    },
    getToken: (tokenName = AUTH_TOKEN_NAME) => {
      return cookies.get(tokenName)
    }
  })
}
